<template>
    <v-dialog v-model="dialog" width="1200">
        <v-card>
            <v-card-title class="justify-center">Change travel period</v-card-title>
            <v-divider></v-divider>
            <v-card-text>
                <v-row no-gutters>
                    <v-col cols="6">
                        <v-radio-group v-model="selectedOption1" dense>
                            <!-- <span>Current arrival {{ huov.arrival0 }}</span> -->
                            <span>Current arrival</span>

                            <div v-for="item in huov.nachtErvoor" :key="item.days" class="d-flex align-center">
                                <div v-if="item.nr === 0" class="d-flex">
                                    <v-radio :label="item.datum" :value="0" :disabled="!item.mogelijk" class="ma-0"></v-radio>
                                    <span class="ml-2 ">{{ item.dag }}</span>
                                </div>
                            </div>

                            <v-divider class="ma-2 pb-2"></v-divider>
                            <span>New arrival</span>
                            <div v-for="item in huov.nachtErvoor" :key="item.days" class="d-flex align-center">
                                <div v-if="item.nr === 2" class="d-flex">
                                    <v-radio :label="item.datum" :value="item.days" :disabled="!item.mogelijk" class="ma-0"></v-radio>
                                    <span class="ml-2 ">{{ item.dag }}</span>
                                    <span class="ml-2 error--text" style="color: red !important" v-if="item.fout">{{ item.fout }}</span>
                                    <span class="ml-2 warning--text" style="color: orange !important" v-else>{{ item.waarschuwing }}</span>
                                </div>
                            </div>
                            <v-divider class="ma-2 pb-2"></v-divider>
                            <div v-for="item in huov.nachtErvoor" :key="item.days" class="d-flex align-center">
                                <div v-if="item.nr === 1" class="d-flex">
                                    <v-radio :label="item.datum" :value="item.days" :disabled="!item.mogelijk" class="ma-0"></v-radio>
                                    <span class="ml-2 ">{{ item.dag }}</span>
                                    <span class="ml-2 error--text" style="color: red !important" v-if="item.fout">{{ item.fout }}</span>
                                    <span class="ml-2 warning--text" style="color: orange !important" v-else>{{ item.waarschuwing }}</span>
                                </div>
                            </div>
                        </v-radio-group>
                    </v-col>
                    <v-col cols="6">
                        <v-radio-group v-model="selectedOption2" dense>
                            <!-- <span>Current departure {{ huov.departure0 }}</span> -->
                            <span>Current departure</span>

                            <div v-for="item in huov.nachtErna" :key="item.days" class="d-flex align-center">
                                <div v-if="item.nr === 0" class="d-flex">
                                    <v-radio :label="item.datum" :value="0" :disabled="!item.mogelijk" class="ma-0"></v-radio>
                                    <span class="ml-2 ">{{ item.dag }}</span>
                                </div>
                            </div>

                            <v-divider class="ma-2 pb-2"></v-divider>
                            <span>New departure</span>
                            <div v-for="item in huov.nachtErna" :key="item.days" class="d-flex align-center">
                                <div v-if="item.nr === 2" class="d-flex">
                                    <v-radio :label="item.datum" :value="item.days" :disabled="!item.mogelijk" class="ma-0"></v-radio>
                                    <span class="ml-2 ">{{ item.dag }}</span>
                                    <span class="ml-2 error--text" style="color: red !important" v-if="item.fout">{{ item.fout }}</span>
                                    <span class="ml-2 warning--text" style="color: orange !important" v-else>{{ item.waarschuwing }}</span>
                                </div>
                            </div>
                            <v-divider class="ma-2 pb-2"></v-divider>
                            <div v-for="item in huov.nachtErna" :key="item.days" class="d-flex align-center">
                                <div v-if="item.nr === 1" class="d-flex">
                                    <v-radio :label="item.datum" :value="item.days" :disabled="!item.mogelijk" class="ma-0"></v-radio>
                                    <span class="ml-2 ">{{ item.dag }}</span>
                                    <span class="ml-2 error--text" style="color: red !important" v-if="item.fout">{{ item.fout }}</span>
                                    <span class="ml-2 warning--text" style="color: orange !important" v-else>{{ item.waarschuwing }}</span>
                                </div>
                            </div>
                        </v-radio-group>
                    </v-col>
                </v-row>
                <v-row no-gutters v-if="showResult">
                    <v-col cols="12">
                        <pre class="result-pre">{{ result.tekst }}</pre>
                    </v-col>
                </v-row>
            </v-card-text>

            <v-divider></v-divider>
            <v-card-actions>
                <div>
                    <v-checkbox
                        v-if="selectedHasWarning"
                        v-model="hostAgreed"
                        hide-details
                        dense
                        class="mt-0 pt-0">
                        <template v-slot:label>
                            <v-icon v-if="!hostAgreed" color="warning" class="mr-1">mdi-alert</v-icon>
                            <span :class="hostAgreed ? 'green--text' : 'warning--text'">
                                The host has agreed with the chosen arrival/departure dates.
                            </span>
                        </template>
                    </v-checkbox>
                    <v-checkbox
                        v-if="selectedIsAirbnb"
                        v-model="clientAgreed"
                        hide-details
                        dense
                        class="mt-0 pt-0">
                        <template v-slot:label>
                            <v-icon v-if="!clientAgreed" color="warning" class="mr-1">mdi-alert</v-icon>
                            <span :class="clientAgreed ? 'green--text' : 'warning--text'">
                                Airbnb client has agreed with the new costs, and the dates in Airbnb have already been changed.
                            </span>
                        </template>
                    </v-checkbox>
                </div>
                <v-spacer/>
                <v-btn class="primary" x-small v-on:click="applyChange" :disabled="(selectedOption1 === 0 && selectedOption2 === 0) || (selectedHasWarning && !hostAgreed) || (selectedIsAirbnb && !clientAgreed) || (!result.success)">Apply change</v-btn>
                <v-btn class="primary" x-small v-on:click="closeDialog">Close</v-btn>
            </v-card-actions>
        </v-card>
    </v-dialog>
</template>

<script>

    export default {
        props: {
        },
        data() {
            return {
                huov_encrid: "",
                huov: {},
                result: {
                    success: false,
                    tekst: "",
                },
                dialog: false,
                showResult: false,
                selectedOption1: 0,
                selectedOption2: 0,
                hostAgreed: false,
                clientAgreed: false,
            }
        },
        computed: {
            selectedHasWarning() {
                const arr = (this.huov.nachtErvoor || []).find(i => i.days === this.selectedOption1);
                const dep = (this.huov.nachtErna || []).find(i => i.days === this.selectedOption2);
                return !!(arr && arr.waarschuwing) || !!(dep && dep.waarschuwing);
            },
            selectedIsAirbnb() {
                // return this.huov.inpt_code === "airbnb";
                return this.huov.inpt_code === "airbnb" && (this.selectedOption1 !== 0 || this.selectedOption2 !== 0);
            }
        },
        watch: {
            selectedOption1() {
                this.hostAgreed = false;
                this.clientAgreed = false;
                this.calculateCosts();
            },
            selectedOption2() {
                this.hostAgreed = false;
                this.clientAgreed = false;
                this.calculateCosts();
            },
        },
        methods: {
            openDialog(huov_encrid) {
                this.dialog = false;
                this.selectedOption1 = 0;
                this.selectedOption2 = 0;
                this.hostAgreed = true;
                this.clientAgreed = false;
                this.showResult = false;
                this.huov_encrid = huov_encrid;
                this.getHouvAlternatePeriodDates(huov_encrid);
                //console.log(huov_encrid);
                //this.dialog = true;
            },
            getHouvAlternatePeriodDates(huov_encrid) {
                this.$axios.post("ares/json/ares/huov/getHouvAlternatePeriodDates.p", {
                    header: {
                        token: this.$session.get("ARES"),
                        clientSessionId: this.$session.id(),
                        request: "getHouvAlternatePeriodDates"
                    },
                    getHouvAlternatePeriodDates: {
                        huov_encrid: huov_encrid,
                    }
                }).then(res => {
                    if (res.data.error) {
                        console.log(res.data.error);
                    } else {
                        this.huov = res.data.getHouvAlternatePeriodDates;
                        this.dialog = true;
                    }
                });
            },
            calculateCosts() {
                if (this.selectedOption1 === 0 && this.selectedOption2 === 0) {
                    this.showResult = false;
                    return;
                }
                this.$axios.post("ares/json/ares/huov/getHouvAlternatePeriodCalcCosts.p", {
                    header: {
                        token: this.$session.get("ARES"),
                        clientSessionId: this.$session.id(),
                        request: "getHouvAlternatePeriodCalcCosts"
                    },
                    getHouvAlternatePeriodCalcCosts: {
                        huov_encrid: this.huov_encrid,
                        selectedOption1: this.selectedOption1,
                        selectedOption2: this.selectedOption2,
                    }
                }).then(res => {
                    if (res.data.error) {
                        console.log(res.data.error);
                    } else {
                        this.result = res.data.getHouvAlternatePeriodCalcCosts;
                        this.showResult = true;
                    }
                });
            },
            applyChange() {
                if (this.selectedOption1 === 0 && this.selectedOption2 === 0) {
                    this.result = {
                        success: false,
                        tekst: "Please select new arrival and/or departure dates.",
                    };
                    this.showResult = true;
                    return;
                }
                this.$axios.post("ares/json/ares/huov/setHouvAlternatePeriod.p", {
                    header: {
                        token: this.$session.get("ARES"),
                        clientSessionId: this.$session.id(),
                        request: "setHouvAlternatePeriod"
                    },
                    setHouvAlternatePeriod: {
                        huov_encrid: this.huov_encrid,
                        selectedOption1: this.selectedOption1,
                        selectedOption2: this.selectedOption2,
                    }
                }).then(res => {
                    if (res.data.error) {
                        console.log(res.data.error);
                    } else {
                        this.result = res.data.setHouvAlternatePeriod;
                        if (this.result.success) {
                            this.$emit("updateData");
                            this.closeDialog();
                        }
                        this.showResult = true;
                    }
                });
            },
            closeDialog() {
                this.dialog = false;
                this.showResult = false;
            }
        }
    }
</script>

<style scoped>
.result-pre {
    max-height: 300px;
    overflow: auto;
}
</style>